/**
 * ShortenerList.js
 *
 * F1 (T3): a curated, built-in snapshot of well-known URL-shortener domains,
 * used to skip tagging a link that is ALREADY a short link — appending
 * utm_* to a short link is useless-to-harmful, since the DESTINATION's own
 * UTM (set before it was shortened) wins after the redirect, and the extra
 * query params are pure noise (some shorteners even choke on them). See
 * research canon: ~/.claude/agent-memory/code-research/utm-linker-settings-ia-2026-07-01.md
 * §3 ("Shortener-detection validation").
 *
 * This is a CURATED ~40-entry SUBSET, not the full external list — cross-
 * checked against **PeterDaveHello/url-shorteners**
 * (https://github.com/PeterDaveHello/url-shorteners), a maintained,
 * high-quality domain list used for allowlist/blocklist purposes. Global
 * shorteners + the RU/CIS shorteners this plugin's piter deploy needs
 * (clck.ru, vk.cc, ...). Snapshot-in-code, NO runtime fetch — updated per
 * plugin release. The admin can add site-specific/regional entries via the
 * Shortened-Link Skip card's "Additional Domains" field (Scope & Exclusions
 * section) rather than waiting on a plugin update.
 *
 * @type {string[]}
 */
export const SHORTENER_DOMAINS = [
    // Global
    'bit.ly',
    't.co',
    'tinyurl.com',
    'goo.gl',
    'ow.ly',
    'is.gd',
    'cutt.ly',
    'buff.ly',
    'rebrand.ly',
    'rb.gy',
    'shorturl.at',
    'tiny.cc',
    't.ly',
    'soo.gd',
    'lnkd.in',
    'fb.me',
    'amzn.to',
    'bl.ink',
    's.id',
    'short.io',
    'v.gd',
    'x.co',
    'adf.ly',
    'git.io',
    'po.st',
    'bit.do',
    'shrtco.de',
    'chilp.it',
    'snip.ly',
    'tr.im',
    'dub.sh',
    'waa.ai',

    // RU / CIS
    'clck.ru',
    'vk.cc',
    'vk.link',
    'u.to',
    'clc.to',
    'clc.am',
    'goo.su',
    'gg.gg',
];
